// Insight banner colors — static constants, these are not to be changed
export const insightBannerColors = {
  alerts: "#ffbbbc",
  badInsights: "#fff7bb",
  goodInsights: "#bbffc0",
  neutral: "#bbc8ff",
};

// Error color
export const errorColor = "#BA1A1A";

// Temperature range visualization colors
export const heatRangeColors = {
  low: "#2A7B9B",
  medium: "#EEF6F4",
  high: "#DD3B00",
};
